import * as React from 'react';
import { Confirm, Edit, useEditContext } from 'react-admin';
import { useCallback } from 'react';
import { useRefresh, useTranslate } from 'ra-core';
import { SurveyForm } from './SurveyForm';
import { fromGenericToUTC } from '../../lib/i18n/utils';
import { RecordEditTitle } from '../../components/RecordTitle';

export const SurveyEdit = (props: any) => {
  const transform = data => ({
    ...data,
    publishDate: data.publishDate ? fromGenericToUTC(data.publishDate) : null,
  });

  return (
    <Edit {...props} title={<RecordEditTitle property="title" />} transform={transform}>
      <SurveyEditForm />
    </Edit>
  );
  
};

export function SurveyEditForm() {
  const { save, isLoading, record } = useEditContext();
  const refresh = useRefresh();
  const translate = useTranslate();
  const [pendingUpdate, setPendingUpdate] = React.useState(null);
  const onClose = useCallback(() => {
    setPendingUpdate(null);
  }, [setPendingUpdate]);

  const onConfirm = useCallback(() => {
    save(pendingUpdate);
  }, [save, pendingUpdate]);


  React.useEffect(() => {
    if (record && record.id) {
      refresh();
    }
  }, [record, refresh]);
  return (
    <>
      <SurveyForm onSubmit={setPendingUpdate} />
      <Confirm
        isOpen={!!pendingUpdate}
        loading={isLoading}
        title={translate('lto.screens.survey_edit.confirm.title')}
        content={translate('lto.screens.survey_edit.confirm.description')}
        onConfirm={onConfirm}
        onClose={onClose}
      />
    </>
  );
}
